import { Box, FlexLayout, H4, Icon } from '@deity/falcon-ui';
import { Select } from '@deity-io/portal-ui';
import { Tooltip } from 'components/Tooltip';
import type { FC } from 'react';

interface IOptionsPicker {
  isEditable: boolean;
  property: string;
  name?: string;
  options: any[];
  value: string | number | undefined;
  description: string;
  disableClearable?: boolean;
  error?: boolean;
  onSelect: (val) => void;
}
const OptionsPicker: FC<IOptionsPicker> = ({
  isEditable,
  error,
  property,
  name,
  options,
  value,
  description,
  disableClearable = true,
  onSelect
}) => (
  <FlexLayout p="xs" bg="panelLight" borderRadius="small" width="full">
    <FlexLayout alignItems="center" width="full">
      <FlexLayout width="full" alignItems="center" justifyContent="space-between" mb="xs">
        <H4 fontWeight="bold" mr="xs" style={{ textTransform: 'capitalize' }}>
          {name || property}
        </H4>
        {description && (
          <Tooltip content={description} direction="left">
            <Icon src="helpOutline" color="secondary" stroke="transparent" />
          </Tooltip>
        )}
      </FlexLayout>
      <Box width="full">
        <Select
          label={property}
          onChange={(option: any) => onSelect(option?.value)}
          options={options?.map(option => ({
            value: option,
            label: option
          }))}
          error={error}
          value={{ value: (value as any) || '', label: (value as any) || '' }}
          disabled={!isEditable}
          disableClearable={disableClearable}
          autoComplete
        />
      </Box>
    </FlexLayout>
  </FlexLayout>
);

export default OptionsPicker;
